import { render, staticRenderFns } from "./DummyPaymentPage.vue?vue&type=template&id=67547184&"
import script from "./DummyPaymentPage.vue?vue&type=script&lang=js&"
export * from "./DummyPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports